export enum CommunityPublishState {
    EXTERNAL = 1,
    INTERNAL = 2,
    DISABLED = 3,
    SUSPENDED = 4,
    ONBOARDING_STEP_1 = 5,
}